// extracted by mini-css-extract-plugin
module.exports = {"jump":"Jump_jump__N8ivM","fade_in":"Jump_fade_in__ZBfzC"};